module.exports = __webpack_public_path__ + "img/action-B.be695034.svg";